import Foundation from "@microsoft/fast-components-foundation-react";
import { TypographySize, TypographyTag } from "@microsoft/fast-components-react-base";
import { classNames } from "@microsoft/fast-web-utilities";
import React from "react";
import { Typography } from "../typography";
import { DisplayNamePrefix } from "../utilities";
import { CaptionSize, CaptionTag, } from "./caption.props";
class Caption extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            size: void 0,
            managedClasses: void 0,
            tag: void 0,
        };
    }
    /**
     * Renders the component
     */
    render() {
        return (React.createElement(Typography, Object.assign({}, this.unhandledProps(), { tag: TypographyTag[this.props.tag], size: this.size(), className: this.generateClassNames() }), this.props.children));
    }
    generateClassNames() {
        return super.generateClassNames(classNames(this.props.managedClasses.caption, [
            this.props.managedClasses[`caption__${this.props.size}`],
            true,
        ]));
    }
    size() {
        return this.props.size === CaptionSize._2 ? TypographySize._9 : TypographySize._8;
    }
}
Caption.defaultProps = {
    tag: CaptionTag.p,
    size: CaptionSize._1,
    managedClasses: {},
};
Caption.displayName = `${DisplayNamePrefix}Caption`;
export default Caption;
export * from "./caption.props";
